var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoopShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9833_5488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9833_5488)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9833_5488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9833_5488)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9833_5488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 8,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H6V13H14V5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9833_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8241 10.3977L13.2771 9.56909L12.7211 9.93576L13.2667 10.7664C13.3052 10.8225 13.3273 10.8881 13.3306 10.9561C13.3339 11.024 13.3183 11.0915 13.2854 11.1511C13.2522 11.2132 13.2025 11.2649 13.1418 11.3007C13.0812 11.3364 13.0118 11.3548 12.9414 11.3537H10.2931L10.7857 10.8621L10.3151 10.3901L9.47407 11.2291C9.412 11.2915 9.36287 11.3655 9.32944 11.4469C9.29604 11.5283 9.27897 11.6156 9.2793 11.7036C9.2796 11.7916 9.29727 11.8787 9.33123 11.9599C9.36523 12.0411 9.4149 12.1147 9.4774 12.1767L10.3171 12.9997L10.7837 12.5241L10.2697 12.0191H12.9427C13.1334 12.0197 13.3206 11.9686 13.4846 11.8713C13.6485 11.774 13.783 11.634 13.8737 11.4664C13.9646 11.3009 14.008 11.1136 13.9993 10.9251C13.9905 10.7365 13.9299 10.554 13.8241 10.3977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92034 6.00411C9.98554 6.00388 10.0498 6.01964 10.1076 6.04994C10.1653 6.08028 10.2148 6.12428 10.2516 6.17811L11.676 8.33311L10.9377 8.18744L10.809 8.84144L12.0156 9.07944C12.1021 9.09654 12.191 9.09634 12.2774 9.07884C12.3637 9.06138 12.4458 9.02694 12.5187 8.97758C12.5917 8.92821 12.6541 8.86484 12.7025 8.79118C12.7508 8.71754 12.7841 8.63501 12.8003 8.54844L13.0283 7.32711L12.3727 7.20478L12.231 7.96444L10.808 5.81078C10.7102 5.66328 10.577 5.54264 10.4206 5.45994C10.2642 5.37721 10.0895 5.33501 9.91258 5.33724C9.73564 5.33948 9.56208 5.38601 9.40778 5.47264C9.25348 5.55928 9.12334 5.68321 9.02934 5.83311L8.61768 6.48911L9.18201 6.84378L9.59468 6.18678C9.62878 6.13098 9.67664 6.08491 9.73364 6.05294C9.79068 6.02094 9.85494 6.00414 9.92034 6.00411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15264 8.48424L8.29597 9.25424L8.95164 9.13324L8.72364 7.91057C8.7074 7.82404 8.6742 7.74154 8.62594 7.6679C8.57767 7.59427 8.51527 7.5309 8.4424 7.4815C8.3695 7.4321 8.28754 7.39764 8.20124 7.38007C8.11494 7.36254 8.02604 7.36224 7.93964 7.37924L6.73364 7.6169L6.86264 8.2709L7.59064 8.12724L6.15964 10.4032C6.06027 10.5605 6.00537 10.7417 6.0008 10.9277C5.9962 11.1136 6.04214 11.2973 6.13364 11.4592C6.2244 11.6244 6.3582 11.7619 6.52084 11.8571C6.68347 11.9523 6.86887 12.0016 7.0573 11.9999H8.33364V11.3332H7.0573C6.98784 11.3341 6.9194 11.3162 6.8593 11.2814C6.7992 11.2465 6.74967 11.196 6.71597 11.1352C6.68287 11.0773 6.6662 11.0114 6.6678 10.9447C6.66937 10.8779 6.68914 10.8129 6.72497 10.7566L8.15264 8.48424Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5488",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9833_5488",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9833_5488",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9833_5488",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopShort);
export default __webpack_public_path__ + "static/media/Loop-Short.8dc5a1726f4b17164067fdc5a2fa0bc1.svg";
export { ForwardRef as ReactComponent };